export default __webpack_public_path__ + "b16abe8abf96bd8575f8274dac174838.svg";